import React from "react";
import { businessTone, businessLabel } from "@/lib/masterOrderApi";

const TONES = {
  work:    { bg: "#F1E7D3", fg: "#5B4326", ring: "#DCC6A0" },
  planned: { bg: "#EEE6D7", fg: "#7A6A55", ring: "#D6C8AC" },
  ready:   { bg: "#DDE6D3", fg: "#3E5236", ring: "#B6C7A0" },
  draft:   { bg: "#EDE7DF", fg: "#7A6A55", ring: "#D0C4B0" },
};

export default function StatusBadge({ status, tone, children, testid }) {
  const t = tone || (status ? businessTone(status) : "draft");
  const c = TONES[t] || TONES.draft;
  return (
    <span
      className="inline-flex items-center rounded-full px-2.5 py-0.5 text-[10.5px] tracking-wide whitespace-nowrap"
      style={{ background: c.bg, color: c.fg, boxShadow: `inset 0 0 0 1px ${c.ring}` }}
      data-testid={testid || (status ? `mo-status-${status}` : undefined)}
    >
      {children || (status ? businessLabel(status) : "")}
    </span>
  );
}
